import { hasValue } from '@amsanalytics/react-shared-library';
import { Button, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { useState } from 'react';
import { IDealerServiceDecisionReasonCode } from '../../../Interfaces/Common/IDealerServiceDecisionCodeReason';
import { DialogProps } from '../DialogProps';
import styles from './_adverse-actions-dialog.module.scss';

export interface AdverseActionsDialogProps extends DialogProps<string[]> {
  dealerServiceDecisionReasonCodes: IDealerServiceDecisionReasonCode[]; // List of dealer service decision reason codes
}

export default function AdverseActionsDialog(props: AdverseActionsDialogProps) {
  // Denial reason search text
  const [denialReasonSearchText, setDenialReasonSearchText] = useState('');
  // List of dealerServiceDecisionReasonCode IDs user has selected to associate with the decision
  const [selectedDenialReasonIds, setSelectedDenialReasonIds] = useState<string[]>([]);
  return (
    <div className={styles.adverseActionsDialogContainer}>
      <DialogTitle id='form-dialog-title'>{props.title || 'Choose Adverse Action Reasons'}</DialogTitle>
      <DialogContent className={styles.adverseActionsDialogContent}>
        <TextField
          value={denialReasonSearchText}
          onChange={(e) => setDenialReasonSearchText(e.target.value as string)}
          type='search'
          placeholder='Search for reasons...'
          style={{ marginBottom: '1em', height: '40px' }}
        />
        {props.dealerServiceDecisionReasonCodes
          .filter((reason) => reason.description.toUpperCase().includes(denialReasonSearchText.toUpperCase()))
          .sort((reason1, reason2) => (reason1.sortOrder || 0) - (reason2.sortOrder || 0))
          .map((reason) => (
            <Checkbox
              key={reason.id}
              label={reason.description}
              checked={selectedDenialReasonIds.includes(reason.id)}
              onChange={(e: CheckboxChangeEvent) => {
                if (e.value) {
                  setSelectedDenialReasonIds([...selectedDenialReasonIds, reason.id]);
                } else {
                  setSelectedDenialReasonIds(selectedDenialReasonIds.filter((dr) => dr !== reason.id));
                }
              }}
              style={{ cursor: 'pointer', margin: '5px 0' }}
            />
          ))}
        {hasValue(denialReasonSearchText) &&
          props.dealerServiceDecisionReasonCodes.filter((reason) =>
            reason.description.toUpperCase().includes(denialReasonSearchText.toUpperCase())
          ).length === 0 && <p style={{ margin: 0 }}>No denial reasons found for your search.</p>}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => props.accept && props.accept(selectedDenialReasonIds)}
          disabled={selectedDenialReasonIds.length === 0}
          color='primary'
          variant='contained'
        >
          Save
        </Button>
        <Button autoFocus onClick={props.closeDialog} color='secondary' variant='contained'>
          Cancel
        </Button>
      </DialogActions>
    </div>
  );
}
